import { createModel } from '@rematch/core';
import { v4 as uuid } from 'uuid';
import { RecordModel, RecordIDModel } from '@equifinance/shared';
import { RootModel } from '.';

const fields = [
  'personId',
  'type',
  'balance',
  'consolidate',
  'accountNumber',
  'sortCode',
  'reference',
] as const;
export type ExistingCredit = RecordIDModel<typeof fields[number]>;

const existingCreditModel = createModel<RootModel>()({
  ...RecordModel<ExistingCredit>(fields),
  effects: (dispatch) => ({
    async createExistingCredit(personId) {
      dispatch.existingCredit.CREATE(uuid(), { personId });
    },
  }),
});

export default existingCreditModel;
